import {action} from 'mobx'

export class LoaderStore {
    public appLoaderElement: HTMLElement | null = null
    private _counter: number = 0

    @action
    public hideAppLoader(isInit?: boolean) {
        if (!this.appLoaderElement) return
        if (!this.appLoaderElement.classList.contains('hide')) {
            if (this._counter > 0 && !isInit) {
                this._counter--
            }
            if (this._counter === 0) {
                this.appLoaderElement.classList.add('hide')
            }
        }
    }

    @action
    public showAppLoader() {
        if (!this.appLoaderElement) return
        this.appLoaderElement.classList.remove('invisible')
        window.setTimeout(() => {
            if (!this.appLoaderElement) return
            this._counter++
            this.appLoaderElement.classList.remove('hide')
        }, 0)
    }
}